module.exports = __webpack_public_path__ + "static/api-error.63daa386cb01d0750a7b6603e9da3867.svg";